module.exports = __webpack_public_path__ + "media/Speaker_lower_3rd.f9b4a703.mp4";